import React from 'react';
import { Col, Typography } from 'antd';
import { ActiveIcon, EarningsIcon, LikeIcon, LogInIcon, SignUpIcon, UserPaymentIcon } from '../Icon';
import moment from 'moment';

const { Text } = Typography;

const Artist = ({usersDetailsData}: any) => (
  <>
    <h3 className="user-activity-title">Earnings</h3>
    <div className="user-activity">
      <Col span={24} style={{ display: 'flex' }}>
        <EarningsIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Total earning</Text>
          <Text>{`₪ ${usersDetailsData?.earnings?.total}`}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex'}}>
        <EarningsIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Subs. earning</Text>
          <Text>{`₪ ${usersDetailsData?.earnings?.subscriptions_amount}`}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex'}}>
        <EarningsIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Tips earning</Text>
          <Text>{`₪ ${usersDetailsData?.earnings?.tips_amount}`}</Text>
        </div>
      </Col>
    </div>
    <h3 className="user-activity-title">Earning date</h3>
    <div className="user-activity">
      <Col span={24} style={{ display: 'flex' }}>
        <UserPaymentIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">First earning</Text>
          <Text>{moment(usersDetailsData?.earnings?.first).format('ddd MMMM Do YYYY')}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex'}}>
        <UserPaymentIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Last earning</Text>
          <Text>{moment(usersDetailsData?.earnings?.last).format('ddd MMMM Do YYYY')}</Text>
        </div>
      </Col>
    </div>
    <h3 className="user-activity-title">Activity</h3>
    <div className="user-activity">
      <Col span={24} style={{ display: 'flex' }}>
        <ActiveIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Active subscriptions</Text>
          <Text>{usersDetailsData?.active_subscriptions}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <LikeIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Liked</Text>
          <Text>{usersDetailsData?.posts?.likes}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <LikeIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Total subs plans</Text>
          <Text>{usersDetailsData?.earnings?.subscriptions_count}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <LikeIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Tips</Text>
          <Text>{usersDetailsData?.earnings?.tips_count}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <LikeIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Total Post</Text>
          <Text>{usersDetailsData?.posts?.posts}</Text>
        </div>
      </Col>
    </div>
    <h3 className="user-activity-title">Log in information</h3>
    <div className="user-info">
      <Col span={12} style={{ display: 'flex' }}>
        <SignUpIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Sign up</Text>
          <Text>{moment(usersDetailsData?.created_at).format('ddd MMMM Do YYYY, h:mm:ss')}</Text>
        </div>
      </Col>
      <Col span={12} style={{ display: 'flex' }}>
        <LogInIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Last log in</Text>
          <Text>{moment(usersDetailsData?.last_active).format('ddd MMMM Do YYYY, h:mm:ss')}</Text>
        </div>
      </Col>
    </div>
  </>
);

export default Artist;
